import DataLoadError, {
  DataLoadDefaultErrors,
} from "../../../utils/data-load-error/data-load-error";

export enum OrderUpdateErrorType {
  PASSENGERS_DO_OVERLAP = "PASSENGERS_DO_OVERLAP",
  NODE_ALREADY_CHECKED_OUT = "NODE_ALREADY_CHECKED_OUT",
  RESULT_TIMING_NOT_POSSIBLE = "RESULT_TIMING_NOT_POSSIBLE",
}

export enum OrderUpdateUnprocessableEntityErrorType {
  TOO_LONG_RIDE = "TOO_LONG_RIDE",
}

export type OrderUpdateTooLongRideError = DataLoadError<
  OrderUpdateUnprocessableEntityErrorType.TOO_LONG_RIDE,
  {}
>;

export type OrderUpdatePassengersDoOverlapError = DataLoadError<
  OrderUpdateErrorType.PASSENGERS_DO_OVERLAP,
  {}
>;

export type OrderUpdateNodeAlreadyCheckedOutError = DataLoadError<
  OrderUpdateErrorType.NODE_ALREADY_CHECKED_OUT,
  {}
>;

export type OrderUpdateResultTimingNotPossibleError = DataLoadError<
  OrderUpdateErrorType.RESULT_TIMING_NOT_POSSIBLE,
  {}
>;

type OrderUpdateError =
  | DataLoadDefaultErrors
  | OrderUpdateTooLongRideError
  | OrderUpdatePassengersDoOverlapError
  | OrderUpdateNodeAlreadyCheckedOutError
  | OrderUpdateResultTimingNotPossibleError;

export default OrderUpdateError;
